import { combineReducers } from "redux";
import productItemsReducer from "./productsItems/reducer";
import cartItemsReducer from "./cartItems/reducer";

const rootReducer = combineReducers({
  productItems: productItemsReducer,
  cartItems: cartItemsReducer,
});

export default rootReducer;
